import React, { useEffect, useState } from 'react';
import ApiUrl from '../../utils/config';
import { useNavigate } from 'react-router-dom';
import { PersonClient, PersonCreateModel, Role, RoleClient, Gender } from '../../utils/apiClient';
import axios from 'axios';
import AppContext from '../../AppContext';
import { handleError } from '../../utils';
import { DateLocal, DateType } from '../../common/components/DateLocal/DateLocal';

export const PersonRegister = () => {
  const appContext = React.useContext(AppContext);
  const [roles, setRoles] = useState<Role[]>([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const roleClient = new RoleClient(ApiUrl, axios);
  const personClient = new PersonClient(ApiUrl, axios);

  const [person, setPerson] = useState<PersonCreateModel>(new PersonCreateModel({
    lastName: '',
    firstName: '',
    patronymic: '',
    birthDate: new Date(),
    city: '',
    roleIds: [],
    gender: Gender.Male,
  }));

  const getRoles = async () => {
    try {
      setLoading(true);
      const response = await roleClient.getRoles();
      setRoles(response ?? []);
    } catch (ex) {
      handleError(appContext!.setNotificationData, ex);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getRoles();
  }, []);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setPerson(new PersonCreateModel({ ...person, [name]: value }));
  };


  const handleRoleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const roleId = parseInt(e.target.value);
    const isChecked = e.target.checked;

    if (isChecked) {
      setPerson(new PersonCreateModel({
        ...person,
        roleIds: [...(person.roleIds || []), roleId]
      }));
    } else {
      setPerson(new PersonCreateModel({
        ...person,
        roleIds: (person.roleIds || []).filter(id => id !== roleId)
      }));
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const result = await personClient.createPerson(person);
      navigate(`/persons/${result.id}`);
    } catch (ex) {
      handleError(appContext!.setNotificationData, ex);
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="register-person">
      <h2>Register Person</h2>

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Last Name:</label>
          <input
            type="text"
            name="lastName"
            value={person.lastName}
            onChange={handleInputChange}
            required
          />
        </div>

        <div className="form-group">
          <label>First Name:</label>
          <input
            type="text"
            name="firstName"
            value={person.firstName}
            onChange={handleInputChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Patronymic (optional):</label>
          <input
            type="text"
            name="patronymic"
            value={person.patronymic || ''}
            onChange={handleInputChange}
          />
        </div>

        <div className="form-group">
          <label>Дата рождения:</label>
          <DateLocal
            type={DateType.date}
            value={person.birthDate ? new Date(person.birthDate) : undefined}
            onChange={(date) => date && setPerson(new PersonCreateModel({ ...person, birthDate: date }))}
            width={200}
            isClearable={false}
          />
        </div>

        <div className="form-group">
          <label>Пол:</label>
          <select name="gender" value={person.gender ?? Gender.Male} onChange={handleInputChange} required>
            <option value={Gender.Male}>Мальчик</option>
            <option value={Gender.Female}>Девочка</option>
          </select>
        </div>

        <div className="form-group">
          <label>City:</label>
          <input
            type="text"
            name="city"
            value={person.city}
            onChange={handleInputChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Roles:</label>
          <div className="checkbox-group">
            {roles.map(role => (
              <div key={role.id} className="checkbox-item">
                <input
                  type="checkbox"
                  id={`role-${role.id}`}
                  value={role.id}
                  checked={(person.roleIds || []).includes(role.id!)}
                  onChange={handleRoleChange}
                />
                <label htmlFor={`role-${role.id}`}>{role.name}</label>
              </div>
            ))}
          </div>
        </div>

        <div className="form-actions">
          <button type="submit" className="btn">Зарегистрировать</button>
          <button type="button" className="btn btn--back" onClick={() => navigate('/persons')}>Отмена</button>
        </div>
      </form>
    </div>
  );
};
